module.exports = __webpack_public_path__ + "static/img/secondarychongqingzhi.3bacf3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondarychongqingzhi.jpg
// module id = u+N3
// module chunks = 46